export enum TaxInclusive {
  Exclusive = 1,
  Inclusive = 2,
}

export enum TaxInclusiveText {
  Exclusive = 'exclusive',
  Inclusive = 'inclusive',
}
